


















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import SectionTitle from '@/modules/shared/shared/components/SectionTitle.vue';
import { layout } from '@/modules/shared/shared/store/namespaces';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import { TutorialsView } from '@/modules/infodayco/shared/domain/tutorials.view';
import InfoFileBox from '@/modules/infodayco/shared/components/InfoFileBox.vue';
import { TutorialFile } from '@/modules/infodayco/shared/domain/tutorial-file';
import { tutorials } from '@/modules/infodayco/shared/store/namespaces';
import { TutorialsActions } from '@/modules/infodayco/tutorials/store/tutorials.actions';
import { TutorialsGetters } from '@/modules/infodayco/tutorials/store/tutorials.getters';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import { GuideFile } from '@/modules/infodayco/shared/domain/guide-file';
import BaseModal from '@/modules/shared/layouts/components/BaseModal.vue';
import { VideoTutorial } from '@/modules/infodayco/shared/domain/video-tutorial';

@Component({
    name: 'tutorials',
    components: { BaseModal, InfoFileBox, SectionTitle },
})
export default class Tutorials extends Vue {
    private isLoading: boolean = false;
    private loadingDelete: boolean = false;
    private toDeleteFile: TutorialFile | VideoTutorial | null = null;

    $refs!: {
        modal: any;
    };

    async mounted() {
        this.changeTitle({
            title: 'TUTORIALES',
            route: ['MIS GUÍAS Y TUTORIALES'],
        });
        this.isLoading = true;
        const failed = await this.fetchView();
        if (failed) {
            failed.showError();
        }
        this.isLoading = false;
    }

    public async openFile(file: TutorialFile) {
        const failed = await this.download(file);
        if (failed) {
            failed.showError();
        }
    }

    public async deleteFile(file: TutorialFile) {
        this.toDeleteFile = file;
        this.$refs.modal.openModal();
    }

    private async executeDelete() {
        this.loadingDelete = true;
        let failed;
        if (this.toDeleteFile && this.toDeleteFile.hasOwnProperty('url')) {
            failed = await this.deleteVideo(this.toDeleteFile as VideoTutorial);
        } else {
            failed = await this.deleteTutorial(this.toDeleteFile as TutorialFile);
        }
        if (failed) {
            failed.showError();
        } else {
            EventBus.$emit(
                EventBusMessages.SHOW_SUCCESS,
                'Se ha eliminado el archivo de manera satisfactoria',
            );
        }
        this.loadingDelete = false;
        this.$refs.modal.closeModal();
    }

    public get isEmpty(): boolean {
        return !(this.view.videos.length > 0 && this.view.tutorials.length > 0);
    }

    @tutorials.Action(TutorialsActions.FETCH_VIEW)
    fetchView!: () => Promise<RequestResponse>;

    @tutorials.Action(TutorialsActions.DOWNLOAD_TUTORIAL)
    download!: (tutorial: TutorialFile) => Promise<RequestResponse>;

    @tutorials.Action(TutorialsActions.DELETE_TUTORIAL)
    deleteTutorial!: (tutorial: TutorialFile) => Promise<RequestResponse>;

    @tutorials.Action(TutorialsActions.DELETE_VIDEO)
    deleteVideo!: (tutorial: VideoTutorial) => Promise<RequestResponse>;

    @tutorials.Getter(TutorialsGetters.GET_VIEW)
    view!: TutorialsView;

    @layout.Mutation(LayoutMutations.CHANGE_TITLE)
    changeTitle!: (layout: LayoutTitle) => void;
}
